import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const PaymentFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen gradient-bg flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full"
      >
        <Card className="p-8 border-slate-200 shadow-xl text-center" data-testid="payment-failure-card">
          <div className="w-20 h-20 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-rose-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-3" style={{fontFamily: 'Manrope'}}>
            Pago No Completado
          </h1>
          
          <p className="text-slate-600 mb-8 leading-relaxed">
            Tu pago no pudo ser procesado. Por favor, verifica tus datos e inténtalo nuevamente.
          </p>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8">
            <p className="text-sm text-amber-800">
              Si el problema persiste, contáctanos para asistencia.
            </p>
          </div>
          
          <div className="flex gap-3">
            <Button
              data-testid="retry-payment-button"
              onClick={() => navigate(-1)}
              className="flex-1 bg-teal-600 hover:bg-teal-700 h-11"
            >
              Reintentar Pago
            </Button>
            <Button
              data-testid="back-home-button"
              onClick={() => navigate('/')}
              variant="outline"
              className="flex-1 h-11"
            >
              Volver
            </Button>
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentFailure;